import React from 'react'
import { useTranslation } from 'react-i18next'
import { TopBar } from '../../components'
import './calcapp.scss'
import { getStorage } from 'helpers'
import { colors } from 'styles/colors'

export const Calcapp = () => {
    const { t } = useTranslation()
    const { commision_calculator_url: commissionCalculatorUrl } =
        getStorage('country_config')

    return (
        <>
            <div className="sticky-header" id="sticky-header">
                <TopBar back color={colors.blue}>
                    {t('calcapp.calcappTitle')}
                </TopBar>
            </div>
            <div>
                <object
                    data={commissionCalculatorUrl}
                    type="text/html"
                    className="calc-app"
                >
                    Alternative Content
                </object>
            </div>
        </>
    )
}
